import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'message'
})
export class MessageErrorPipe implements PipeTransform {
    constructor(private translate: TranslateService) {

    }
    transform(message: string) {
        let alert
        switch (message) {
            case "error":
                alert = this.translate.instant('PleaseFindWarnings');
                break;
            case "warning":
                alert = this.translate.instant('PleaseFindWarnings');
                break;
            case "success":
                alert = this.translate.instant('Success');
                break;
        }
        return alert;
    }
}